import { h } from 'preact'
import MethodBox from './MethodBox'
import Switcher from '../control/Switcher'
import globals from '../../utils/globals'

interface Props {
  isEnabled: boolean,
  toggle: () => void
}

const DefaultAuthenticationBox = ({ isEnabled, toggle }: Props) =>
  <MethodBox providerName='default'>
    <img src={`${globals('basePath')}images/logo-no-text.png`} />
    <div>
      <div class='method method-default'>Default authentication</div>
      <div class='method-description'>inSided's default authentication method: email, username and password</div>
    </div>
    <Switcher
      on={isEnabled}
      onChange={() => toggle()}
    />
  </MethodBox>

export default DefaultAuthenticationBox
